
/* START_TEMPLATE */
define('plugins/hbs/hbs.custom!coach/cumulative/view/templates/dashboard',['hbs','handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers);
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n<div class=\"ko-subheader\">\n    <h1>Stats</h1>\n\n    <div class=\"stats-location\">\n        <a href=\"";
  if (helper = helpers.gameStatsUrl) { stack1 = helper.call(depth0, {hash:{}}); }
  else { helper = (depth0 && depth0.gameStatsUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{}}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"game-stats\">Game Stats</a>\n        <a class=\"cumulative-stats selected\">Season Stats</a>\n    </div>\n    <div class=\"season-switcher\">\n        <div class=\"subhead-spinner\">\n            <span id=\"season-loading\"></span>\n        </div>\n\n        <a href=\"#\" class=\"ko-season-toggle-back ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.previousSeasonId), {hash:{},inverse:self.noop,fn:self.program(2, program2, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"><img src=\"/Content/kickoff/icons/chevronleft.svg\" /></a>\n\n        <div class=\"selected-season\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.season)),stack1 == null || stack1 === false ? stack1 : stack1.seasonLabel)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</div>\n\n        <a href=\"#\" class=\"ko-season-toggle-forward ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.nextSeasonId), {hash:{},inverse:self.noop,fn:self.program(2, program2, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"><img src=\"/Content/kickoff/icons/chevronright.svg\"/></a>\n    </div>\n</div>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return "hidden";
  }

  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hasUniversalWebNavigationFeature), {hash:{},inverse:self.noop,fn:self.program(1, program1, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
Handlebars.registerPartial('coach_cumulative_view_templates_dashboard', t);
return t;
});
/* END_TEMPLATE */
;